import { changeMomentLocale, changePolyglotValues, languagePreference } from '../index'
import firebase from 'firebase'
import Polyglot from 'node-polyglot'

export function changeLocale (locale) {
  return new Promise((resolve, reject) => {
    window.localStorage.setItem(languagePreference, locale)
    changeMomentLocale(locale)
    getPhrasesFromDatabase(locale).then((newData) => {
      resolve(newData)
    })
  })
}

function handlePhrases (phrases, locale) {
  const newPolyglot = new Polyglot({phrases: phrases, locale: locale})
  newPolyglot.extend({
    'staticFields': {
      'numMonths': `%{smart_count}  ${phrases.staticFields['commonFields'].month} |||| %{smart_count}  ${phrases.staticFields['commonFields'].months} `,
      'numWeeks': `%{smart_count}  ${phrases.staticFields['commonFields'].week} |||| %{smart_count}  ${phrases.staticFields['commonFields'].weeks} `,
      'numDays': `%{smart_count}  ${phrases.staticFields['commonFields'].day} |||| %{smart_count}  ${phrases.staticFields['commonFields'].days} `,
      'numYears': `%{smart_count}  ${phrases.staticFields['commonFields'].year} |||| %{smart_count}  ${phrases.staticFields['commonFields'].years} `
    }
  })
  return changePolyglotValues(newPolyglot)
}

function getPhrasesFromDatabase (locale) {
  return new Promise((resolve, reject) => {
    const rootRef = firebase.database().ref()
    const config = rootRef.child('crescendo').child('translationKeys').child(locale)
    config.on('value', dataSnapshot => {
      const phrases = dataSnapshot.val()
      if (phrases) {
        resolve(handlePhrases(phrases, locale))
      } else {
        reject(new Error('No Phrases'))
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/resources/polyglot.js